import type { TooltipRenderProps } from 'react-joyride';
import { Button } from '@/components/ui/button';
import { X, MousePointerClick } from 'lucide-react';

export function TourTooltip({
  continuous,
  index,
  step,
  size,
  backProps,
  closeProps,
  primaryProps,
  skipProps,
  tooltipProps,
  isLastStep,
}: TooltipRenderProps) {
  const isAction = (step as any).data?.isActionStep ?? false;
  const customNextText = (step as any).data?.nextButtonText;

  const nextLabel = customNextText
    ? customNextText
    : isLastStep
      ? 'Finish'
      : 'Next';

  return (
    <div
      {...tooltipProps}
      className={`bg-popover text-popover-foreground border rounded-lg shadow-lg max-w-sm w-[340px] z-[10001] ${
        isAction ? 'border-l-[3px] border-l-primary' : ''
      }`}
    >
      <div className="flex items-start justify-between p-4 pb-2">
        <div className="space-y-1 flex-1 mr-2">
          {step.title && (
            <h4 className="text-sm font-semibold leading-tight flex items-center gap-1.5">
              {isAction && <MousePointerClick className="h-3.5 w-3.5 text-primary shrink-0" />}
              {step.title as string}
            </h4>
          )}
          <p className="text-xs text-muted-foreground">
            Step {index + 1} of {size}
          </p>
        </div>
        <button
          {...closeProps}
          className="h-6 w-6 rounded-sm opacity-70 hover:opacity-100 flex items-center justify-center"
        >
          <X className="h-3.5 w-3.5" />
        </button>
      </div>

      <div className="px-4 pb-3">
        <p className="text-sm leading-relaxed">{step.content as string}</p>
      </div>

      <div className="flex items-center justify-between p-4 pt-2 border-t">
        <Button variant="ghost" size="sm" {...skipProps} className="text-xs">
          Skip tour
        </Button>
        <div className="flex gap-2">
          {index > 0 && (
            <Button variant="outline" size="sm" {...backProps}>
              Back
            </Button>
          )}
          {continuous && (
            <Button size="sm" {...primaryProps}>
              {nextLabel}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
